<template>
    <div id="cartontoCon">
        <a-row>
            <a-form :form="form">
                <a-col :span="5" style="left: 40px">
                    <a-form-item>
                        <label class="blackLabel">{{fieldMap.ctcLoadId.displayName }}:</label>
                        <a-input v-model="loadId" :disabled="true" style="height: 25px;width: 50%;" :placeholder="fieldMap.ctcLoadId.displayName" @pressEnter="enterConNoLoading"/>
                    </a-form-item>
                </a-col>
                <a-col :span="6">
                    <a-form-item>
                        <label class="blackLabel">{{ fieldMap.ctcContainer.displayName }}:</label>
                        <a-input v-model="containerNo" style="height: 25px;width: 65%;" :placeholder="fieldMap.ctcContainer.displayName" @pressEnter="enterConNoLoading"/>
                    </a-form-item>
                </a-col>
                <a-col :span="2">
                    <a-form-item>
                        <label style="width: 50%;color: black">{{ fieldMap.ctcHidden.displayName }}:</label>
                        <a-switch v-model="isHiddenTable" @change="handleSwitchChange" :disabled="isSwitchDisabled"  />
                    </a-form-item>
                </a-col>
                <a-col :span="9"  >

                    <a-button type="primary"    v-for="(item, index) in btnFunArr"  :key="index"   v-if="item.code == 'CTC-Save' && item.arr.length > 0" size="small" style="margin: 0 5px;" @click="save">{{ item.arr[0].name }}</a-button>
                    <a-button type="primary"    v-for="(item, index) in btnFunArr"   :key="index"  v-if="item.code == 'CTC-NewContainer' && item.arr.length > 0"   size="small" style="margin: 0 5px;" @click="newContainer">{{ item.arr[0].name  }}</a-button>
                    <a-button type="primary"    v-for="(item, index) in btnFunArr"   :key="index"  v-if="item.code == 'CTC-CartonByWave' && item.arr.length > 0"  size="small" style="margin: 0 5px;" @click="searchCartonByWave">{{ item.arr[0].name  }}</a-button>
                    <a-upload
                            name="file"
                            :showUploadList="false"
                            :customRequest="importSscc"
                            :headers="headers"
                            :data="uploadData"
                            method="post"
                    >
                        <a-button type="primary"    v-for="(item, index) in btnFunArr" :key="index"   v-if="item.code == 'CTC-ImportSSCC' && item.arr.length > 0" size="small" style="margin: 0 10px;">{{ item.arr[0].name  }}</a-button>
                    </a-upload>

                </a-col>
                <!--Print-->
                <a-col :span="2" v-for="item in btnFunArr" :key="item.uid" >
                    <div v-if="item.code == 'CTC-Print'" id="printPackList">
                        <a-dropdown-button v-if="item.arr.length  >  0">
                            {{ $t('pubGicSet.Print') }}
                            <a-menu slot="overlay" >
                                <a-menu-item v-for="tt in item.arr" :key="tt.uid" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                            </a-menu>
                        </a-dropdown-button>
                    </div>
                </a-col>
            </a-form>
        </a-row>
        <a-row >
            <a-col :span="20" style="left: 10px">
                <a-form :form="form">
                    <a-row v-if="!isHiddenTable">
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcSeal.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['seal',{ initialValue: loadShipmentData.seal != null ?  loadShipmentData.seal : fieldMap.ctcSeal.defaultVal  }]"
                                        :placeholder="fieldMap.ctcSeal.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcContainerType.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['containerType',{ initialValue: loadShipmentData.containerType  != null ? loadShipmentData.containerType : fieldMap.ctcContainerType.defaultVal   }]"
                                        :placeholder="fieldMap.ctcContainerType.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcVesselFight.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['vesselFight',{ initialValue: loadShipmentData.vesselFight  != null ? loadShipmentData.vesselFight : fieldMap.ctcVesselFight.defaultVal }]"
                                        :placeholder="fieldMap.ctcVesselFight.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcVoyage.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['voyage',{ initialValue: loadShipmentData.voyage != null ? loadShipmentData.voyage : fieldMap.ctcVoyage.defaultVal  }]"
                                        :placeholder="fieldMap.ctcVoyage.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcMbl.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['mbl',{ initialValue: loadShipmentData.mbl != null ?  loadShipmentData.mbl : fieldMap.ctcMbl.defaultVal  }]"
                                        :placeholder="fieldMap.ctcMbl.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcHbl.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['hbl',{ initialValue: loadShipmentData.hbl != null ? loadShipmentData.hbl : fieldMap.ctcHbl.defaultVal   }]"
                                        :placeholder="fieldMap.ctcHbl.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcDriver.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['driver',{ initialValue: loadShipmentData.driver != null ? loadShipmentData.driver: fieldMap.ctcDriver.defaultVal  }]"
                                        :placeholder="fieldMap.ctcDriver.displayName"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="!isHiddenTable">
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcEtd.displayName" >
                                <a-date-picker
                                        size="small"
                                        style="width: 100%;"
                                        format="YYYY-MM-DD"
                                        valueFormat="YYYY-MM-DD"
                                        v-decorator="['etd', { initialValue:loadShipmentData.etd != null ? loadShipmentData.etd : fieldMap.ctcEtd.defaultVal  }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcEta.displayName" >
                                <a-date-picker
                                        size="small"
                                        style="width: 100%;"
                                        format="YYYY-MM-DD"
                                        valueFormat="YYYY-MM-DD"
                                        v-decorator="['eta', { initialValue:loadShipmentData.eta != null ? loadShipmentData.eta : fieldMap.ctcEta.defaultVal  }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcPortOfLoading.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['portOfLoading',{ initialValue: loadShipmentData.portOfLoading != null ? loadShipmentData.portOfLoading : fieldMap.ctcPortOfLoading.defaultVal }]"
                                        :placeholder="fieldMap.ctcPortOfLoading.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcPortOfDischarge.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['portOfDischarge',{ initialValue: loadShipmentData.portOfDischarge != null ?  loadShipmentData.portOfDischarge : fieldMap.ctcPortOfDischarge.defaultVal  }]"
                                        :placeholder="fieldMap.ctcPortOfDischarge.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcPortOfDestination.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['portOfDestination',{ initialValue: loadShipmentData.portOfDestination != null ? loadShipmentData.portOfDestination : fieldMap.ctcPortOfDestination.defaultVal  }]"
                                        :placeholder="fieldMap.ctcPortOfDestination.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcLoadFrom.displayName" >
                                <a-date-picker
                                        size="small"
                                        style="width: 100%;"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        valueFormat="YYYY-MM-DD HH:mm:ss"
                                        v-decorator="['loadFrom', { initialValue:loadShipmentData.loadFrom != null ? loadShipmentData.loadFrom : fieldMap.ctcLoadFrom.defaultVal }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcLoadTo.displayName" >
                                <a-date-picker
                                        size="small"
                                        style="width: 100%;"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        valueFormat="YYYY-MM-DD HH:mm:ss"
                                        v-decorator="['loadTo', { initialValue:loadShipmentData.loadTo != null ? loadShipmentData.loadTo : fieldMap.ctcLoadTo.defaultVal  }]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="!isHiddenTable">
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcHudf1.displayName">
                                <a-input v-decorator="['hudf1',{ initialValue: loadShipmentData.hudf1  != null ? loadShipmentData.hudf1 : fieldMap.ctcHudf1.defaultVal   }]" :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcHudf2.displayName">
                                <a-input v-decorator="['hudf2',{ initialValue: loadShipmentData.hudf2  != null ? loadShipmentData.hudf2 : fieldMap.ctcHudf2.defaultVal   }]" :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcHudf3.displayName">
                                <a-input v-decorator="['hudf3',{ initialValue: loadShipmentData.hudf3 != null ?  loadShipmentData.hudf3 : fieldMap.ctcHudf3.defaultVal   }]" :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcHudf4.displayName">
                                <a-input v-decorator="['hudf4',{ initialValue: loadShipmentData.hudf4 != null ?  loadShipmentData.hudf4 : fieldMap.ctcHudf4.defaultVal   }]" :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcHudf5.displayName">
                                <a-input v-decorator="['hudf5',{ initialValue: loadShipmentData.hudf5 != null ? loadShipmentData.hudf5 : fieldMap.ctcHudf5.defaultVal   }]" :placeholder="$t('publicLang.PleaseEnter')" size="small" style="width:100%"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="!isHiddenTable">
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcEdiSendtime1.displayName">
                                <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['ediSendtime1', { initialValue:loadShipmentData.ediSendtime1 != null ? loadShipmentData.ediSendtime1 :  fieldMap.ctcEdiSendtime1.defaultVal   }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcEdiSendtime2.displayName">
                                <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['ediSendtime2', { initialValue:loadShipmentData.ediSendtime2  != null ? loadShipmentData.ediSendtime2 :  fieldMap.ctcEdiSendtime2.defaultVal  }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcEdiSendtime3.displayName">
                                <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['ediSendtime3', { initialValue:loadShipmentData.ediSendtime3  != null ? loadShipmentData.ediSendtime3 :  fieldMap.ctcEdiSendtime3.defaultVal   }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcEdiSendtime4.displayName">
                                <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['ediSendtime4', { initialValue:loadShipmentData.ediSendtime4  != null ? loadShipmentData.ediSendtime4 :  fieldMap.ctcEdiSendtime4.defaultVal  }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" class="ml15">
                            <a-form-item class="genericFrom" :label="fieldMap.ctcEdiSendtime5.displayName">
                                <a-date-picker size="small" style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-decorator="['ediSendtime5', { initialValue:loadShipmentData.ediSendtime5  != null ? loadShipmentData.ediSendtime5 :  fieldMap.ctcEdiSendtime5.defaultVal   }]"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="!isHiddenTable">
                        <a-col :span="3" class="ml15">
                            <a-form-item :label="fieldMap.ctcRemarks.displayName" >
                                <a-input
                                        class="inputStyle"
                                        v-decorator="['remarks',{ initialValue: loadShipmentData.remarks != null ? loadShipmentData.remarks  :  fieldMap.ctcRemarks.defaultVal  }]"
                                        :placeholder="fieldMap.ctcRemarks.displayName"
                                />
                            </a-form-item>
                        </a-col>
                        <a-divider  style="top:10px"/>
                    </a-row>
                    <a-row style="top:10px">
                        <a-col :span="12">
                            <a-form-item style="left:20px" :label-col="formFirstItemLayout.labelCol" :wrapper-col="formFirstItemLayout.wrapperCol" :label="fieldMap.ctcTrackingNo.displayName">
                                <a-input :placeholder="fieldMap.ctcTrackingNo.displayName" ref="ssccLoadingConTocon" v-model="containerSsccVal" @pressEnter="enterSsccLoading"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item v-bind="tailFormItemLayout">
                                <a-checkbox
                                        :checked="removeCarToConCked"
                                        @change="removeLoadingChange">
                                    {{fieldMap.ctcRemove.displayName }}
                                </a-checkbox>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <a-row style="top: 20px">
                    <vxe-table
                            border
                            resizable
                            :data.sync="loadingCartontoCanTable"
                            max-height="350"
                            show-footer
                            :footer-method="footerMethod"
                            :footer-cell-class-name="footerCellClassName"
                            ref="loadingCartonGrid"
                            size="mini">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                        <vxe-table-column
                                width="200"
                                field="relId"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                :title="fieldMap.ctcRelId.displayName"
                        >
                        </vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="packId"
                                :title="fieldMap.ctcPackId.displayName">
                        </vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="carton"
                                :title="fieldMap.ctcCarton.displayName">
                        </vxe-table-column>
                        <vxe-table-column
                                width="300"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="sscc"
                                :title="fieldMap.ctcSscc.displayName">
                        </vxe-table-column>
                        <vxe-table-column
                                width="300"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="logisticsid"
                                :title="fieldMap.ctcLogisticsid.displayName">
                        </vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="skuQty"
                                :title="fieldMap.ctcSkuQty.displayName">
                        </vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-col>
            <a-col :span="4" >
                <label style="width: 100%;text-align: center;">{{ fieldMap.ctcLoadedCartonQty.displayName}}:</label>
                <div style="height: 100%;width: 100%;font-size: 98px;text-align: center;color: green;font-weight: bold">{{loadedCartonQtyNum}}</div>
            </a-col>
        </a-row>

        <!--WaveId弹出窗-->
        <search-carton-by-wave ref="queryWindow" @checkedCode="checkedCode"></search-carton-by-wave>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import searchCartonByWave from "../../components/searchCartonByWave";
    import cookie from "../../../../api/cookie";
    import axios from "axios";
    export default{
        components:{
            searchCartonByWave,
        },
        props :{
            uid: {
                type: String,
                required: true
            },
            fieldMap:{
                type: Object,
                required: true
            },
            btnFunArr:{
                type: Array,
                required: true
            }
        },
        data(){
            return{
                headers: {
                    "Authorization": cookie.getBearerToken()
                },
                loadingCartontoCanTable: [],
                loadedCartonQtyNum: 0,
                form: this.$form.createForm(this),
                formFirstItemLayout: {
                    labelCol: { span: 6 },
                    wrapperCol: { span: 15 },
                },
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 8 },
                },
                tailFormItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 8 },
                },
                containerSsccVal:'',
                loadShipmentData:{},
                removeCarToConCked: false,
                uploadData:{},
                isHiddenTable: false,
                isSwitchDisabled: false,

                loadId: '',
                containerNo: '',
                UDF: {},

            }
        },
        created() {
            this.init();

        },
        methods:{
            init() {
                let params = {
                    uid: this.uid
                }
                ajax.get(api.LOADINGSHIPMENTBYLOADUID,params).then(res=>{
                    if(res.code == 200){
                        this.loadShipmentData = res.data;
                        this.loadId = res.data.loadId;
                        this.containerNo = res.data.vechicalNo;
                        this.$refs.ssccLoadingConTocon.focus()
                        this.loadingTable();
                    }else{
                        this.$refs.containerNoRef.focus()
                    }
                })
                //  console.info('获取页面按钮')
                // this.getHudfAndEdiSendTime();
            },
            getHudfAndEdiSendTime(){
                ajax.get(api.GETHUDFANDEDISENDTIME, null).then(res => {
                    if (res.code == 200) {
                        this.UDF = res.data;
                    }
                });
            },
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                return [
                    columns.map((column, columnIndex) => {
                        if (column.property == "sscc") {
                            return this.loadingCartontoCanTable.length;
                        }
                        if (
                            ['skuQty'].includes(
                                column.property
                            )
                        ) {
                            return that.sumPubFn(column.property);
                        }
                    })
                ];
            },
            handleSwitchChange(checked){
                if (! checked) {
                    this.isHiddenTable = false;
                }else{
                    this.isHiddenTable = true;
                }
            },
            sumPubFn(val) {
                let arr = this.loadingCartontoCanTable;
                var sum = 0;
                for (let index in arr) {
                    sum += arr[index][val];
                }
                return sum;
            },
            save(){
                let that = this;
                this.form.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        let params = values;
                        params.loadId = that.loadId;
                        params.containerNo = that.containerNo;
                        ajax.post(api.SAVELOADHEADERANDSHIPMENT, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg,2);
                                this.formQuery.resetFields();
                                this.init();
                            } else {
                                this.$customMessage.warning(res.msg,2);
                            }
                        })
                    }
                });
            },
            newContainer(){
                this.containerSsccVal = ''
                this.containerNo = ''
                this.$refs.containerNoRef.focus()
            },
            enterConNoLoading(){
                this.loadingTable()
                this.$refs.ssccLoadingConTocon.focus()
            },
            removeLoadingChange(){
                this.removeCarToConCked = ! this.removeCarToConCked
            },
            enterSsccLoading(){
                let params = {
                    cartonToContainer: {
                        containerNo: this.containerNo,
                        sscc: this.containerSsccVal
                    },
                    uid:this.uid,
                    remove:this.removeCarToConCked
                }
                ajax.post(api.LOADINGSCAN,params).then(res=>{
                    if(res.code == 200){
                        this.containerSsccVal = ''
                        this.loadingTable()
                        this.removeCarToConCked =false;
                    }else{
                        this.$refs.ssccLoadingConTocon.select()
                        this.removeCarToConCked =false;
                        this.$emit('subError', res.msg)
                    }
                })
            },
            loadingTable(){
                let params = {
                    containerNo: this.containerNo,
                    uid:this.uid
                }
                ajax.get(api.LOADINGTABLE,params).then(res=>{
                    if(res.code == 200){
                        this.loadingCartontoCanTable = res.data
                        this.loadedCartonQtyNum = this.loadingCartontoCanTable.length
                    }
                })
            },
            deleteSscc(){
                let Records = this.$refs.loadingCartonGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let deleteSsccList = [];
                for(let i in Records){
                    deleteSsccList.push(Records[i].sscc)
                }
                let that = this;
                this.$customConfirm({
                    title: this.$t('pubGicSet.AreyoudeleTask'),
                    content: "",
                    onOk() {
                        let params = new FormData();
                        params.append("ssccList", deleteSsccList);
                        params.append("uid", that.uid);
                        params.append("containerNo", that.containerNo);
                        ajax.post(api.DELETELOADINGSSCC, params).then(res => {
                            if (res.code == 200) {
                                that.loadingTable();
                                that.$message.success(res.msg)
                            } else {
                                that.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });

            },
            searchCartonByWave(){
                if(this.containerNo == null || this.containerNo == '') {
                    this.$customMessage.warning(this.$t('pubGicSet.ContainerNo')+this.$t('job.notNull'), 2);
                    return;
                }
                this.$refs.queryWindow.show(this.containerNo,this.uid)
            },
            checkedCode(row) {
                let name = ''
                if(row != null ){
                    this.loadingTable();
                }

            },
            importSscc(data) {
                if(this.containerNo == null || this.containerNo == '') {
                    this.$customMessage.warning(this.$t('pubGicSet.ContainerNo')+this.$t('job.notNull'), 2);
                    return;
                }
                let that = this;
                const formData = new FormData()
                formData.append('file', data.file)
                let uidTemp = '';
                if(that.uid!=undefined&&that.uid!=null&&that.uid!='') {
                    uidTemp = that.uid;
                }
                formData.append('uid', uidTemp);
                formData.append('containerNo', that.containerNo)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.LOADINGIMPORTSSCC,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.loadingTable();
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            printByBtnConfig(btnConfig){   // 根据用户配置打印
                console.log("print---start"+btnConfig);
                if(this.loadId == "" && this.containerNo == ""){
                    this.$customMessage.error("loadId,containerNo " + this.$t('job.notNull'));
                    return;
                }
                let ajaxurl = ajax.ajaxUrl();
                this.isBtnajax = true
                let that = this
                // 构造参数
                let params = {
                    gmcUid: btnConfig.gmcUid,
                    uid: '',
                    btnName: btnConfig.name,
                    btnUid: btnConfig.uid
                }


                // 添加 订单号

                params.loadId = this.loadId
                params.containerNo = this.containerNo


                // console.info(params)
                axios.get(ajaxurl + api.PRINTPREVIEW, {
                    params ,
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function(res) {
                    let resHeader = res.headers;
                    let contentType = resHeader["content-type"];
                    let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                    if(excelContentType.indexOf(contentType) !=-1) {
                        //excel
                        that.isBtnajax = false
                        var data  = res;
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    } else {
                        //pdf
                        that.pubPdfMsgfn(res);
                    }
                });
            },
            // paf接口返回值处理
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            //            pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
        }
    }
</script>
<style>
    .inputStyle {
        width: 100%;
        height: 25px
    }
    .ant-form-item{
        margin-bottom:10px;
        font-size: 12px;
    }
    .blackLabel{
        color: black;
        font-weight: bold;
        width: 25%;
    }
    .ml15{
        margin-left: 15px;
    }
    .ant-input-lg{
        font-size: 12px;
    }
    .ant-input{
        font-size: 12px;
    }
</style>